import * as React from "react";
function SvgFrameText(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <g fill="none" stroke="currentColor" strokeWidth={2}>
        <path d="M23 7v2h2M9 25v-2H7m18 0h-2v2M7 9h2V7" />
        <path d="M23 9V7H9v2H7v14h2v2h14v-2h2V9h-2z" />
        <path d="M9 7V5H5v4h2m18 0h2V5h-4v2m0 18v2h4v-4h-2M7 23H5v4h4v-2" />
      </g>
      <path
        fill="currentColor"
        d="M18 20l-.57-1.9h-2.84L14 20h-1.75L15 12h2l2.75 8zm-1-3.31l-.88-2.92-.14-.53c-.11.46-.45 1.61-1 3.45z"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgFrameText);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
